import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import AdminDashboard from "./AdminDashboard";
import RegisterUser from "./RegisterUser";
import AssignAnalyst from "./AssignAnalyst";
import ViewReports from "./ViewReports";
import ManageOrganizations from "./ManageOrganizations";
import ManageUsers from "./ManageUsers";
import TaxSystems from "./TaxSystems";
import SalesActivity from "./SalesActivity";
import AuditLogs from "./AuditLogs";
import Profile from "../Profile";
import {
  FiBarChart2,
  FiUserPlus,
  FiUsers,
  FiBriefcase,
  FiLink,
  FiFileText,
  FiMessageSquare,
  FiUser,
  FiGlobe,
  FiActivity,
  FiShield,
} from "react-icons/fi";
import AdminChat from "./AdminChat";
import { useTranslation } from "react-i18next";

const ADMIN_LINKS = (t) => [
  { path: "", label: t("nav.dashboard"), icon: FiBarChart2 },
  {
    path: "/register-user",
    label: t("admin.registerUser", "Register User"),
    icon: FiUserPlus,
  },
  { path: "/users", label: t("admin.users", "Users"), icon: FiUsers },
  {
    path: "/organizations",
    label: t("admin.organizations", "Organizations"),
    icon: FiBriefcase,
  },
  {
    path: "/assign-analyst",
    label: t("admin.assignAnalyst", "Assign Analyst"),
    icon: FiLink,
  },
  {
    path: "/view-reports",
    label: t("admin.viewReports", "View Reports"),
    icon: FiFileText,
  },
  {
    path: "/tax-systems",
    label: t("admin.taxSystems", "Tax Systems"),
    icon: FiGlobe,
  },
  {
    path: "/sales-activity",
    label: t("admin.salesActivity", "Sales Activity"),
    icon: FiActivity,
  },
  {
    path: "/audit-logs",
    label: t("admin.auditLogs", "Audit Logs"),
    icon: FiShield,
  },
  { path: "/chat", label: t("nav.chat"), icon: FiMessageSquare },
  { path: "/profile", label: t("profile.profile"), icon: FiUser },
];

function AdminPortal() {
  const { t } = useTranslation();
  return (
    <div className="portal-layout">
      <Sidebar links={ADMIN_LINKS(t)} basePath="/admin" />
      <div className="portal-main">
        <Routes>
          <Route
            index
            element={
              <>
                <Header title={t("admin.dashboardTitle", "Admin Dashboard")} />
                <AdminDashboard />
              </>
            }
          />
          <Route
            path="register-user"
            element={
              <>
                <Header title={t("admin.registerUser", "Register User")} />
                <RegisterUser />
              </>
            }
          />
          <Route
            path="users"
            element={
              <>
                <Header title={t("admin.users", "Users")} />
                <ManageUsers />
              </>
            }
          />
          <Route
            path="organizations"
            element={
              <>
                <Header title={t("admin.organizations", "Organizations")} />
                <ManageOrganizations />
              </>
            }
          />
          <Route
            path="assign-analyst"
            element={
              <>
                <Header title={t("admin.assignAnalyst", "Assign Analyst")} />
                <AssignAnalyst />
              </>
            }
          />
          <Route
            path="view-reports"
            element={
              <>
                <Header title={t("admin.viewReports", "View Reports")} />
                <ViewReports />
              </>
            }
          />
          <Route
            path="tax-systems"
            element={
              <>
                <Header title={t("admin.taxSystems", "Tax Systems")} />
                <TaxSystems />
              </>
            }
          />
          <Route
            path="sales-activity"
            element={
              <>
                <Header title={t("admin.salesActivity", "Sales Activity")} />
                <SalesActivity />
              </>
            }
          />
          <Route
            path="audit-logs"
            element={
              <>
                <Header title={t("admin.auditLogs", "Audit Logs")} />
                <AuditLogs />
              </>
            }
          />
          <Route path="profile" element={<Profile />} />
          <Route
            path="chat"
            element={
              <>
                <Header title={t("nav.chat")} />
                <AdminChat />
              </>
            }
          />
          <Route path="*" element={<Navigate to="/admin" />} />
        </Routes>
      </div>
    </div>
  );
}
export default AdminPortal;
